import React from "react";
import { Container } from "@mui/material";
import { IndexAdminPorcentaje } from "../../../components/Admin/Inicio/Porcentaje/Inicio";

export const PaginaIndexPorcentajeAdmin = () => {
    return(
        <Container maxWidth='lg'>
        
            <IndexAdminPorcentaje/>
        </Container>
    )
}